/* Tiny mutable singleton, like OQC's state.js. Screens read it, main.js re-renders. */

export const state = {
  user: null,
  hasDfs: false,
  googleEnabled: false,
  googleClientId: null,
  allowedDomains: [],

  /* screen routing: auth | home | setup | analyzing | summary */
  screen: "auth",
  mode: "gsc",            // setup mode: gsc | serp
  scans: [],
  scanId: null,           // the scan being watched / shown
  results: null,          // revived R for the active scan

  /* Files picked on the setup screen, kept across re-renders so opening the account
     popup (or any repaint) does not throw away what the user already uploaded. */
  setupDraft: null,
};

export const newSetupDraft = () => ({
  slots: {},                     // kind -> {name, rows, data, file}
  extras: { trad: [], ai: [] },  // received-but-skipped basenames, per zone
  errors: [],
  submitError: null,
});